export default __webpack_public_path__ + "static/media/time.11bc4000.svg";